import React from 'react';
import MediaQuery, {useMediaQuery} from 'react-responsive';
import * as PropTypes from 'prop-types';
import store from 'Data/store';
import {VIEWPORT_BREAKPOINTS} from './viewportConstants';

// for functional components
export const useDesktopMediaQuery = () =>
    useMediaQuery({query: `(min-width: ${VIEWPORT_BREAKPOINTS.DESKTOP}px)`});

// for non-functional components
export const isDesktopExplorer = () => {
    const isExplorer = store.getState()?.pageState?.layout?.isExplorer;

    return isExplorer && window.innerWidth >= VIEWPORT_BREAKPOINTS.DESKTOP;
};

export const getCardWidthOnDesktop = () =>
    isDesktopExplorer() && document.getElementsByClassName('card-stack-wrapper').length
        ? document.getElementsByClassName('card-stack-wrapper')[0]?.clientWidth +
          document.getElementsByClassName('explorer-menu-wrapper')[0]?.clientWidth
        : 0;

export const useMobileMediaQuery = () =>
    useMediaQuery({query: `(max-width: ${VIEWPORT_BREAKPOINTS.DESKTOP - 1}px)`});

export const Desktop = ({children}) => {
    const isDesktop = useDesktopMediaQuery();
    return isDesktop ? children : null;
};

export const Mobile = ({children}) => {
    const isMobile = useMobileMediaQuery();
    return isMobile ? children : null;
};

Desktop.propTypes = {
    children: PropTypes.node,
};

Mobile.propTypes = {
    children: PropTypes.node,
};

export const ResponsiveComponent = ({children}) => (
    <MediaQuery minWidth={VIEWPORT_BREAKPOINTS.DESKTOP}>{children}</MediaQuery>
);

ResponsiveComponent.propTypes = {
    children: PropTypes.object,
};
